import { useEffect } from "react"

export function useSetPageBackground(cssColor: string | null) {
  useEffect(() => {
    if (!cssColor) return

    const { style } = document.documentElement
    const initialColor = style.getPropertyValue("--main-background-color")

    document.documentElement.style.setProperty(
      "--main-background-color",
      cssColor,
    )

    return () => {
      document.documentElement.style.setProperty(
        "--main-background-color",
        initialColor,
      )
    }
  }, [cssColor])
}
